import React from 'react';
import c from 'classnames';

import { BaseCardProps } from './types';

import CardContent from './Content';
import CardImage from './Image';
import CardLabel from './Label';
import CardSubtitle from './Subtitle';
import CardTitle from './Title';
import CardProfile from './Profile';

import './style.scss';

type CardProps = Pick<BaseCardProps, 'className'>;

interface CardSubComponents {
  Content: typeof CardContent;
  Image: typeof CardImage;
  Label: typeof CardLabel;
  Subtitle: typeof CardSubtitle;
  Title: typeof CardTitle;
  Profile: typeof CardProfile;
}

const Card: React.FC<CardProps> & CardSubComponents = (props) => {
  const {
    className,
    children,
  } = props;

  const classNames = c('Card', className);

  return (
    <article className={classNames}>
      {children}
    </article>
  );
};

Card.Content = CardContent;
Card.Image = CardImage;
Card.Label = CardLabel;
Card.Subtitle = CardSubtitle;
Card.Title = CardTitle;
Card.Profile = CardProfile;

export default Card;
